module.exports = __webpack_public_path__ + "img/collection_dino.c41bea70.png";